import gql from 'graphql-tag';

export const Templates = gql`
  query Templates($organizationId: ID!, $request: GetPaginatedTemplatesRequest) {
    organization(organizationId: $organizationId) {
      templates(request: $request) {
        pagination {
          total
          currentPage
          hasNextPage
          hasPreviousPage
          limit
          offset
          remaining
          totalPages
        }
        results {
          id
          versionId
          type
          name
          status
          labels {
            id
            name
            description
            color
          }
          scoringChecklist {
            id
          }
          thumbnailUrl
          createdAt
          updatedAt
        }
      }
    }
  }
`;
